'use strict';

const PLUS_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5v14"/></svg>`;
const MINUS_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/></svg>`;

// --- x-accordion -----------------------------------------------------------

class XAccordion extends HTMLElement {
    constructor() {
        super();
        this._handleToggle = this._onToggle.bind(this);
    }

    connectedCallback() {
        this.addEventListener('x-accordion-toggle', this._handleToggle);
    }

    disconnectedCallback() {
        this.removeEventListener('x-accordion-toggle', this._handleToggle);
    }

    _onToggle(e) {
        e.stopPropagation();
        const { item } = e.detail;
        const isOpen = item.dataset.state === 'open';

        if ((this.getAttribute('type') || 'single') === 'single') {
            this._items().forEach((i) => i !== item && i._setOpen(false));
        }

        item._setOpen(!isOpen);
    }

    _items() {
        return [...this.querySelectorAll(':scope > x-accordion-item')];
    }
}

// --- x-accordion-item ------------------------------------------------------

class XAccordionItem extends HTMLElement {
    connectedCallback() {
        if (!this.dataset.state) this.dataset.state = 'closed';
    }

    _setOpen(open) {
        this.dataset.state = open ? 'open' : 'closed';

        const trigger = this.querySelector('x-accordion-trigger');
        const content = this.querySelector('x-accordion-content');

        if (trigger) {
            trigger.dataset.state = open ? 'open' : 'closed';
            const btn = trigger.querySelector('.accordion__button');
            if (btn) btn.setAttribute('aria-expanded', String(open));
        }
        if (content) {
            content.dataset.state = open ? 'open' : 'closed';
        }
    }
}

// --- x-accordion-trigger ---------------------------------------------------

class XAccordionTrigger extends HTMLElement {
    connectedCallback() {
        const label = this.innerHTML;
        this.innerHTML = '';

        const header = document.createElement('h3');
        header.className = 'accordion__header';

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'accordion__button';
        button.setAttribute('aria-expanded', 'false');

        const labelSpan = document.createElement('span');
        labelSpan.innerHTML = label;

        const iconWrap = document.createElement('div');
        iconWrap.className = 'accordion__icon-container';
        iconWrap.innerHTML = `
      <span class="accordion__icon accordion__icon--plus">${PLUS_SVG}</span>
      <span class="accordion__icon accordion__icon--minus">${MINUS_SVG}</span>
    `;

        button.append(labelSpan, iconWrap);
        header.append(button);
        this.append(header);

        button.addEventListener('click', () => {
            const item = this.closest('x-accordion-item');
            if (!item) return;
            item.dispatchEvent(
                new CustomEvent('x-accordion-toggle', {
                    bubbles: true,
                    detail: { item },
                }),
            );
        });
    }
}

// --- x-accordion-content ---------------------------------------------------

class XAccordionContent extends HTMLElement {
    connectedCallback() {
        const children = [...this.childNodes];
        const inner = document.createElement('div');
        inner.className = 'accordion__body-inner';
        if (children.length) inner.append(...children);
        const body = document.createElement('div');
        body.className = 'accordion__body';
        body.append(inner);
        this.append(body);
        this.dataset.state = 'closed';
    }
}

// --- Register --------------------------------------------------------------

customElements.define('x-accordion', XAccordion);
customElements.define('x-accordion-item', XAccordionItem);
customElements.define('x-accordion-trigger', XAccordionTrigger);
customElements.define('x-accordion-content', XAccordionContent);
